import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import admin from './modules/admin'
import app from './modules/app'

Vue.use(Vuex)

// 持久化配置
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: ['admin'] // 只持久化admin模块
})

const store = new Vuex.Store({
  modules: {
    admin,
    app
  },
  plugins: [vuexLocal.plugin],
  getters: {
    token: state => state.admin.token,
    refreshToken: state => state.admin.refreshToken,
    adminInfo: state => state.admin.adminInfo,
    permissions: state => state.admin.permissions,
    sidebar: state => state.app.sidebar,
    device: state => state.app.device,
    addRouters: state => state.app.addRouters
  }
})

export default store
